import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get, update, remove } from '~/actions/orderNew';
import Spinner from '~/components/Spinner';
import CustomerPicker from '~/components/CustomerPicker';
import ArticlePicker from '~/components/ArticlePicker';
import MultiPickerCount from '~/components/MultiPickerCount';
import DatePicker from 'react-toolbox/lib/date_picker';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

const MultiArticlePicker = MultiPickerCount(ArticlePicker);

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      item: null,
      changes: {}
    };
  }

  componentDidMount() {
    get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(r => this.setState({ loading: false, item: r.data.order }))
      .catch(() => this.setState({ loading: false }));
  }

  submit() {
    return update(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id,
      this.state.changes
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  remove() {
    return remove(this.props.dispatch, this.context.apiClient, this.props.data.id).then(() =>
      this.context.dialogClose(this.props.dialogId)
    ).then(() => this.props.data.onRemove && this.props.data.onRemove());
  }

  render() {
    if (this.state.loading) {
      return (
        <div
          className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')}
          onClick={() => this.context.dialogClose(this.props.dialogId)}
        >
          <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
            <div className={styleDialog.content}>
              <Spinner />
            </div>
          </div>
        </div>
      );
    }
    if (!this.state.loading && !this.state.item) {
      return (
        <div
          className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')}
          onClick={() => this.context.dialogClose(this.props.dialogId)}
        >
          <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
            <div className={styleDialog.content}>Not found</div>
          </div>
        </div>
      );
    }
    const articleIds =
      this.state.changes.articleIds !== undefined
        ? this.state.changes.articleIds
        : this.state.item.articleIds;

    return (
      <div
        className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')}
        onClick={() => this.context.dialogClose(this.props.dialogId)}
      >
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton
            className={styleDialog.closeButton}
            icon="close"
            onClick={() => this.context.dialogClose(this.props.dialogId)}
          />
          <div className={styleDialog.content}>
            <form
              onSubmit={e => {
                e.preventDefault();
                this.submit();
              }}
            >
              <div style={{ paddingBottom: '10px' }}>
                External reference
                <input
                  style={{ marginLeft: '20px' }}
                  value={
                    this.state.changes.reference !== undefined
                      ? this.state.changes.reference
                      : this.state.item.reference
                  }
                  onChange={e =>
                    this.setState({
                      changes: {
                        ...this.state.changes,
                        reference: e.target.value
                      }
                    })
                  }
                />
              </div>
              <div style={{ paddingBottom: '10px' }}>
                Notes
                <textarea
                  style={{ width: '100%' }}
                  value={
                    this.state.changes.notes !== undefined
                      ? this.state.changes.notes
                      : this.state.item.notes
                  }
                  onChange={e =>
                    this.setState({ changes: { ...this.state.changes, notes: e.target.value } })
                  }
                />
                Article goal
                {typeof articleIds === 'object' && articleIds !== null ? (
                  <div>
                    <MultiArticlePicker
                      value={articleIds}
                      onChange={v =>
                        this.setState({ changes: { ...this.state.changes, articleIds: v } })
                      }
                    />
                    <Button
                      label="Remove article goal"
                      primary
                      onClick={() =>
                        this.setState({ changes: { ...this.state.changes, articleIds: null } })
                      }
                      style={{ width: '100%' }}
                    />
                  </div>
                ) : (
                  <div>
                    <Button
                      label="Set article goal"
                      className={styleLocal.buttonOutline}
                      style={{ width: '100%' }}
                      onClick={() =>
                        this.setState({ changes: { ...this.state.changes, articleIds: {} } })
                      }
                    />
                  </div>
                )}
                <div>
                  <DatePicker
                    label="ETA"
                    locale="en"
                    sundayFirstDayOfWeek
                    value={
                      this.state.changes.eta ||
                      (this.state.item.eta ? new Date(this.state.item.eta) : null)
                    }
                    onChange={v => this.setState({ changes: { ...this.state.changes, eta: v } })}
                    onDismiss={() =>
                      this.setState({
                        changes: { ...this.state.changes, eta: null },
                        item: { ...this.state.item, eta: null }
                      })
                    }
                  />
                </div>
                <div>Customer:&nbsp;
                  <CustomerPicker
                    value={this.state.changes.customerId || this.state.item.customerId}
                    onChange={v => {
                      this.setState({
                        changes: { ...this.state.changes, customerId: v },
                        item: { ...this.state.item, customerId: v },
                      });
                    }}
                  />
                </div>
              </div>
              <Button
                className={styleLocal.buttonRemove}
                label="Delete"
                icon="clear"
                onClick={() =>
                  this.context.dialogPush('message', {
                    content: 'Are you sure?',
                    onConfirm: () => this.remove()
                  })
                }
              />
              <Button label="Save" icon="done" type="submit" primary raised />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/OrderEdit/index.js